import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet default icon path issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

// Colored circle divIcons
const mkIcon = (color) => L.divIcon({
  className: "custom-map-pin",
  html: `<div style="background:${color};width:22px;height:22px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.35)"></div>`,
  iconSize: [22, 22], iconAnchor: [11, 11],
});
export const ICONS = {
  origin: mkIcon("#10B981"),
  dest: mkIcon("#EF4444"),
  driver: mkIcon("#3949AB"),
  zone: mkIcon("#F5A623"),
};

// Fit bounds when points change
const AutoFit = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (!points || points.length === 0) return;
    if (points.length === 1) {
      map.setView(points[0], 14);
    } else {
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [40, 40] });
    }
  }, [points, map]);
  return null;
};

/**
 * Reusable map component.
 * markers = [{ lat, lng, icon, label, popup }]
 * routes  = [[[lat,lng],[lat,lng]], ...]
 */
export default function MapView({
  markers = [],
  routes = [],
  height = 300,
  center = [-12.5933, -69.1893], // Puerto Maldonado default
  zoom = 13,
  testid = "map-view",
}) {
  const points = markers.filter((m) => m.lat && m.lng).map((m) => [m.lat, m.lng]);
  return (
    <div className="rounded-lg overflow-hidden border border-neutral-200" style={{ height }} data-testid={testid}>
      <MapContainer center={center} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((m, i) =>
          m.lat && m.lng ? (
            <Marker key={i} position={[m.lat, m.lng]} icon={m.icon || ICONS.zone}>
              {(m.label || m.popup) && (
                <Popup>
                  {m.label && <div className="font-semibold text-sm">{m.label}</div>}
                  {m.popup && <div className="text-xs text-neutral-600 mt-1">{m.popup}</div>}
                </Popup>
              )}
            </Marker>
          ) : null
        )}
        {routes.map((route, i) => (
          <Polyline key={i} positions={route} pathOptions={{ color: "#3949AB", weight: 4, opacity: 0.6, dashArray: "8,6" }} />
        ))}
        <AutoFit points={points} />
      </MapContainer>
    </div>
  );
}
